import { type ComponentProps } from 'react'
import Link from 'next/link'
import { getLinkRel } from '@/services/storyblok/Storyblok.helpers'
import { Text } from 'ui/src/components/Text/Text'
import { textLink } from './TextLink/TextLink.css'

type WithLinkProps = Pick<ComponentProps<typeof Link>, 'href' | 'target' | 'rel'> & {
  children: string
}

type Props = WithLinkProps & ComponentProps<typeof Text>

export const TextWithLink = ({ children, href, target, rel, ...otherProps }: Props) => {
  return (
    <Text {...otherProps}>
      <WithLink href={href} target={target} rel={rel}>
        {children}
      </WithLink>
    </Text>
  )
}

export const WithLink = (props: WithLinkProps) => {
  const [beforeLink, rest] = props.children.split('[[', 2)

  if (rest === undefined) {
    console.log('TextWithLink | no link placeholder found in text. Consider using a regular Text component instead.')
    return <>{props.children}</>
  }

  const [linkText, afterLink] = rest.split(']]', 2)

  const rel = getLinkRel(props)

  return (
    <span>
      {beforeLink}
      <Link href={props.href} target={props.target} rel={rel} className={textLink}>
        {linkText}
      </Link>
      {afterLink}
    </span>
  )
}
